import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	dropdownAnchor: {
		width: 260,
	},
	searchEmployeeBox: {
		fontSize: 14,
		marginTop: 16,
	},
	sendFromDropdownContainer: {
		alignItems: 'center',
		color: darkGrayFontColor,
		display: 'flex',
		fontSize: 14,
		width: '100%',
		gap: 8,
	},
	popoverStyles: {
		zIndex: 51,
	},
});
